<template>
  <a-month-picker
    :placeholder="fieldProps.placeholder"
    :style="{ width: fieldProps.width ? `${fieldProps.width}px` : '120px' }"
    :disabled-date="disabledDate"
    :format="monthFormat"
    v-model="newMonth"
    @change="onChange"
  >
    <a-icon slot="suffixIcon" type="calendar" />
  </a-month-picker>
</template>
<script>
import moment from "moment";
export default {
  name: "MonthDate",
  props: {
    data: {
      type: String,
      default: "",
    },
    fieldProps: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      monthFormat: "YYYY-MM",
    };
  },
  computed: {
    // 查询参数
    newMonth: function() {
      return this.data ? moment(this.data, this.monthFormat) : null;
    },
  },
  mounted() {},
  methods: {
    moment,
    disabledDate(current) {
      if (!current) {
        return false;
      } else {
        // 大于当前日期不能选 current > moment()
        // 小于当前日期不能选 current < moment().subtract(1, "days")
        // 小于当前日期包括当天不能选 current && current < moment().endOf('day')
        // 只能选前7后7 current < moment().subtract(7, "days") || current > moment().add(7, "d")
        return current > moment();
      }
    },
    onChange(data, dateString) {
      this.$emit("changeBack", dateString);
    },
  },
};
</script>

<style lang="less" scoped></style>
